import { useAsync } from "@/shared/hooks";
import { TeamRow } from "@/swagger";
import { teamPicksLoader } from "../loader/team-picks-loader";
import { Flex } from "@suns/design-system";
import { PickAssetChart } from "./PickAssetChart";

export function TeamPicks({ team }: { team: TeamRow }) {
  const {
    response: pickAssets,
    loading,
    error,
  } = useAsync(teamPicksLoader, { teamId: team.id });

  if (error) throw error;
  if (loading) return <div>Loading..</div>;

  return (
    <Flex gap="lg" direction="down">
      {pickAssets.map((pickAsset, i) => (
        <PickAssetChart key={i} pickAsset={pickAsset} />
      ))}
    </Flex>
  );
}
